var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container safty-info"},[_vm._m(0),_c('list',{attrs:{"data":_vm.records}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container__content title"},[_c('div',{staticClass:"container__border"}),_c('div',{staticClass:"container__title"},[_vm._v("今日安全报警")])])
}]

export { render, staticRenderFns }